import { ReactNode } from 'react';

interface GloryBorderProps {
  children: ReactNode;
  borderRadius?: string;
  innerBorderRadius?: string;
}

export default function GloryBorder({ 
  children, 
  borderRadius = '24px',
  innerBorderRadius = '22px'
}: GloryBorderProps) {
  return (
    <div 
      style={{ borderRadius, padding: '2px' }}
      className="relative bg-white/10"
    >
      <div 
        style={{ borderRadius }}
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
      >
        <div 
          style={{ 
            borderRadius,
            filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))'
          }}
          className="absolute inset-0"
        >
          <div 
            style={{ 
              borderRadius,
              padding: '2px',
              background: `conic-gradient(
                from var(--angle),
                transparent 0%,
                rgba(255, 255, 255, 0.8) 20%,
                transparent 25%
              )`,
              WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude',
              animation: 'glory-border-spin 10s linear infinite',
              willChange: 'background'
            }}
            className="absolute inset-0"
          />
        </div>
      </div>
      <div 
        style={{ borderRadius: innerBorderRadius }}
        className="relative overflow-hidden"
      >
        {children}
      </div>
    </div>
  );
}

